<template>
    <div class="chunk-loading" role="status" :aria-label="$t('chunkLoading')"
         :style="{minHeight: minHeight + 'px'}">
        <div class="chunk-loading__spinner"></div>
    </div>
</template>

<script>
/**
 * Заглушка на месте компонента, который ещё грузится отдельным чанком.
 *
 * Показывается не сразу, а с задержкой: её задаёт `delay` асинхронного
 * компонента (resources/js/components/Async/lazyChunk.js), чтобы при тёплом
 * кеше спиннер не мигал.
 */
export default {
    name: 'ChunkLoading',
    // Vue 2 отдаёт loading-компоненту тот же `data`, что стоял на асинхронном
    // теге, а всё, что не объявлено пропом ниже, без этой строки уедет в
    // атрибуты корневого div. У ArticleBodyEditor на редакторе висит
    // `v-model`, то есть в атрибут `value` спиннера попало бы всё тело статьи
    // целиком.
    inheritAttrs: false,
    props: {
        /**
         * Сколько места держать под ещё не приехавший компонент.
         *
         * Настраивается, потому что заглушка не знает, что за ней грузится:
         * 120 px под редактор на форме правки уместны, а на ЧИТАТЕЛЬСКОМ пути
         * дают скачок вёрстки — ElementView.vue показывает статью в формате
         * Editor.js тем же компонентом и передаёт ему `:min-height="0"`, то
         * есть блок в 120 px возник бы под превью и тут же схлопнулся.
         *
         * Отдельный проп для этого не нужен: имя совпадает с пропом самого
         * EditorJS.vue, и Vue отдаёт `min-height` с асинхронного тега сюда,
         * пока чанк не приехал, и настоящему компоненту — когда приехал.
         * Заглушка занимает ровно столько же, сколько займёт содержимое.
         */
        minHeight: {
            type: Number,
            default: 120,
        },
    },
};
</script>

<style scoped>
/* min-height не здесь, а привязкой в шаблоне: значение задаёт проп minHeight. */
.chunk-loading {
    display: flex;
    align-items: center;
    justify-content: center;
}

.chunk-loading__spinner {
    width: 28px;
    height: 28px;
    border: 3px solid #E3E5EC;
    border-top-color: #4680FF;
    border-radius: 50%;
    animation: chunk-loading-spin 0.8s linear infinite;
}

@keyframes chunk-loading-spin {
    to {
        transform: rotate(360deg);
    }
}

/*
 * Замедляем, а не выключаем: вращение здесь — единственный признак того, что
 * загрузка идёт, а не подвисла, и `animation: none` оставил бы человека с
 * неподвижным кружком без подсказки, ждать ли дальше. Медленный оборот
 * снимает вестибулярную нагрузку, ради которой просят reduced-motion, но
 * сохраняет смысл индикатора.
 */
@media (prefers-reduced-motion: reduce) {
    .chunk-loading__spinner {
        animation-duration: 2.4s;
    }
}
</style>
